import * as angular from "angular";
import {IController} from "angular";

export class ProgramServiceAreasByDistanceTableCtrl implements IController {

  area: any;
  isExpanded: boolean;
  serviceAreasOptionIds: string[];
  excludeServiceAreasIds: string[];
  onUpdateZone: Function;
  onDeleteZone: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  };

  $onChanges(changes) {

  };


  /////////////////////////////////////////////////////////////////////


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceAreasByDistanceTable', {
    bindings: {
      area: '<',
      isExpanded: '<?',
      serviceAreasOptionIds: '<?',
      excludeServiceAreasIds: '<?',
      onUpdateZone: '&',
      onDeleteZone: '&'
    },
    template: require('./program-service-areas-by-distance-table.html').default,
    controller: ProgramServiceAreasByDistanceTableCtrl
  });
